<template lang="pug">
UiPage(:title="$t('billing.title')")
  .container
    UiCard
      UiCardSection
        RestTable(
          namespace="billing"
          :headers="headers"
          ref="billingTable"
          :fetch-handler="getData"
          embed
        )
          template(#cell:name="{ item }")
            RouterLink(
              :to="`/billing/${item.id}/show`"
              label="item.name"
            ) {{ item.name }}
</template>

<script>
import ApiBilling from "@/api/billing.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          width: "40%",
        },
        {
          key: "company_id",
          label: "Business ID",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    getData(params, config) {
      return ApiBilling.FetchList(params, config).then((resp) => {
        return {
          items: resp.data.resellers,
          meta: resp.data.meta,
        };
      });
    },
  },
};
</script>
